import React, { createContext, useContext } from 'react';
import { ChartUpdateStream } from '../services/chart-update-stream.service';

const ChartUpdateStreamContext = createContext<ChartUpdateStream | undefined>(
  undefined
);

type ChartUpdateStreamProviderProps = {
  chartUpdateStream: ChartUpdateStream;
  children: React.ReactNode;
};

export const ChartUpdateStreamProvider = ({
  chartUpdateStream,
  children
}: ChartUpdateStreamProviderProps) => {
  return (
    <ChartUpdateStreamContext.Provider value={chartUpdateStream}>
      {children}
    </ChartUpdateStreamContext.Provider>
  );
};

export const useChartUpdateStreamContext = () => {
  const context = useContext(ChartUpdateStreamContext);

  if (!context) {
    throw new Error(
      'useChartUpdateStreamContext must be used within ChartUpdateStreamProvider'
    );
  }

  return context;
};
